import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import { Panel, PanelGroup, Placeholder } from 'rsuite';
import { useAuth } from '../AuthContext';
import FolderIcon from '@rsuite/icons/Folder';
import { BsCalendar2MonthFill } from 'react-icons/bs';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function Redirector() {
  const { auth } = useAuth();
  const navigate = useNavigate();

  function checkIfLoggedIn(){
    const hasToken = !!auth.token;
    const isAdmin = (auth.role === 'ROLE_ADMIN');


    if (hasToken && isAdmin) {
      toast.success("Välkommen tillbaka, " + auth.firstName + "! 👋", {
                position: 'bottom-right'
              });
        navigate("/admin/dashboard")
    } else {
        navigate("/login")
    }
  }

  useEffect(() => {
    checkIfLoggedIn();
    }, [])


  return (
    <>
        <Helmet>
          <title>{`Omdirigerar...`}</title>
        </Helmet>
        
    </>
  );
}

export default Redirector;
